const loadFloorPlans = () => {
    const floorPlans = document.querySelectorAll('.floor-plan-link')
    for (let floorPlanLink of floorPlans) {
        floorPlanLink.addEventListener('click', (event) => {
            event.preventDefault()

            document.body.classList.add('.modal-visible')

            const floorPlanId = floorPlanLink.getAttribute('data-launch-id')
            const floorPlan = document.querySelector(`[data-floor-plan="${floorPlanId}"]`)
            const floorPlanClose = document.querySelector(`[data-floor-plan-close="${floorPlanId}"]`)

            floorPlan.classList.add('visible')

            floorPlanClose.addEventListener('click', () => {
                document.body.classList.remove('.modal-visible')
                floorPlan.classList.remove('visible')
            })
        })
    }
}

export default loadFloorPlans



// WEBPACK FOOTER //
// ./js/floorPlan.js